import { render } from "./alertModal.vue?vue&type=template&id=125f8316&scoped=true&ts=true"
import script from "./alertModal.vue?vue&type=script&lang=ts"
export * from "./alertModal.vue?vue&type=script&lang=ts"

import "./alertModal.vue?vue&type=style&index=0&id=125f8316&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125f8316"]])

export default __exports__